import React from 'react';
import styled, { keyframes } from 'styled-components';


// Animação do loader
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Estilo para o fundo escuro
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

// Estilo do loader
const LoaderStyled = styled.div`
  width: 50px;
  height: 50px;
  border: 6px solid #fff;
  border-top: 6px solid transparent;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 16px; /* Espaço entre o loader e o texto */
`;

// Estilo do texto
const LoadingText = styled.div`
  color: #fff;
  font-size: 1.2rem;
  text-align: center;
`;

export function Loader({ text = "Carregando..." }) {
  return (
    <Overlay>
      <LoaderStyled />
      <LoadingText>{text}</LoadingText>
    </Overlay>
  );
}
